import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DetailsDivComponent} from './details-div.component';
import {CustomButtonModule} from '../custom-button/custom-button.module';



@NgModule({
  declarations: [DetailsDivComponent],
  exports: [
    DetailsDivComponent
  ],
    imports: [
        CommonModule,
        CustomButtonModule
    ]
})
export class DetailsDivModule { }
